'use client';

import { useSearchParams } from 'next/navigation';
import { useEffect } from 'react';

export default function WhatConvertsLinker() {
  const searchParams = useSearchParams();

  useEffect(() => {
    const wcVisitor = searchParams.get('wc_visitor');
    if (wcVisitor && !document.cookie.includes('wc_visitor=')) {
      document.cookie = `wc_visitor=${wcVisitor};path=/;max-age=31536000`;
    }
  }, [searchParams]);

  return null;
}

